import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface PropTypes {
  rows: number;
}

export function NotesSkeleton(props: PropTypes) {
  return (
    <>
      {[...Array(props.rows)].map((_, i) => (
        <div key={i} className='mb-4'>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <Skeleton width={120} />
            <Skeleton width={72} />
          </div>
          <Skeleton count={2} />
        </div>
      ))}
    </>
  );
}
